module.exports = __webpack_public_path__ + "img/fig18.484974db.jpg";